import { useEffect } from "react";
import { useAuth } from "@/_core/hooks/useAuth";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

/**
 * Auth gate that redirects unauthenticated users to /login.
 * Wrapped routes will only render their content if user is logged in.
 */
export default function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { user, loading, isAuthenticated } = useAuth({
    redirectOnUnauthenticated: true,
    redirectPath: "/login",
  });

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-muted-foreground">Loading...</div>
      </div>
    );
  }

  // If not authenticated, useAuth hook will redirect to /login automatically
  if (!isAuthenticated || !user) {
    return null;
  }

  // User is authenticated - render children
  return <>{children}</>;
}
